//Imports
import React, { useCallback, useEffect } from "react";

//Controls
import { Button, Modal } from "@gpstrackit/gtc-react-controls";

//Components
import {
    NotificationManager,
    NotificationContainer,
} from "Components/Notifications";

//Hooks
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

//Actions
import { manageDeleteManageAssetSubtype, reset } from "./redux/slice";

const DeleteManageAssetSubtype = ({ refresh }) => {

    //Redux
    const dispatch = useDispatch();

    //Language
    const { messages } = useIntl();

    const { open, loading, result, error, assetSubtype, assetSubtypeList } = useSelector((state) => state.manageDeleteManageAssetSubtypeRedux);

    //Handlers and utils
    const handleClose = useCallback(() => dispatch(reset()), []);

    const handleDeleteSubmit = useCallback(() => {
        if (assetSubtype) {
            dispatch(manageDeleteManageAssetSubtype({ ids: [assetSubtype?.id] }));
        }
        if (assetSubtypeList?.length) {
            let ids = assetSubtypeList.map((item) => item?.id)
            dispatch(manageDeleteManageAssetSubtype({ ids: ids }));
        }
    }, [assetSubtype, assetSubtypeList]);

    //Effects
    useEffect(() => {
        if (error) {
            let errorMessage = error.error === "CompanyReadonly" ? error.error : messages["errorMessage"];
            const errorLower = error?.error?.toLowerCase();
            if (errorLower.includes('are in use')) {
                errorMessage = messages['manage_deleteAssetSubtypes_are_in_use']
            }
            NotificationManager.error(
                errorMessage,
                messages["error"],
                3000,
                null,
                null,
                "error"
            );
            dispatch(reset({ error: null }));
        }
    }, [error]);

    useEffect(() => {
        if (!result) return;
        if (result?.delete) {
            const messageSuccess = assetSubtype
                ? messages['manage_deleteAssetSubtype_successMessageUpdate']
                : messages['manage_deleteAssetSubtypes_successMessageUpdate'];

            NotificationManager.success(
                messageSuccess,
                messages["success"],
                3000,
                null,
                null,
                "success"
            );
            refresh();
            dispatch(reset());
        } else {
            NotificationManager.error(
                messages["errorMessage"],
                messages["error"],
                3000,
                null,
                null,
                "error"
            );
            dispatch(reset({ result: null }));
        }
    }, [result]);

    return (
        <Modal
            title={assetSubtype ? messages["manage_deleteAssetSubtype_title"] : messages["manage_deleteAssetSubtypes_title"]}
            size="small"
            open={open}
            handleClose={handleClose}
            loading={loading}
            footer={
                <div>
                    <Button
                        variant="secondary"
                        style={{ marginRight: "5px" }}
                        onClick={() => handleClose()}
                        isDisabled={loading}
                    >
                        {messages["cancel"]}
                    </Button>
                    <Button
                        variant="warning"
                        onClick={() => handleDeleteSubmit()}
                        isDisabled={loading}
                    >
                        {messages["delete"]}
                    </Button>
                </div>
            }
        >
            <div style={{ padding: "10px 25px" }}>
                <p>{assetSubtype ? messages['manage_deleteAssetSubtype_description'] : messages['manage_deleteAssetSubtypes_description']}</p>
                <ul>
                    {assetSubtype ? (
                        <li style={{ wordBreak: "break-word", overflowWrap: "break-word" }}>
                            {assetSubtype?.name}
                        </li>
                    ) : (
                        assetSubtypeList?.map((crew, index) => (
                            <li key={index} style={{ wordBreak: "break-word", overflowWrap: "break-word" }}>
                                {crew.name}
                            </li>
                        ))
                    )}
                </ul>
            </div>
            <NotificationContainer />
        </Modal>
    );
};

export default DeleteManageAssetSubtype;